__turbopack_context__.v({
  "component": "style-module-scss-module__iKV7Ca__component",
});
